// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:400,900);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D, .D-1, .D-2, .D-3, .D-4, .D-5, .D-6, .D-7, .D-8, .D-9, .D-10, .D-11, .D-12, .L, .L-1, .L-2, .L-3, .L-4, .L-5, .L-6, .L-7, .L-8, .L-9, .L-10, .L-11, .L-12, .T, .T-1, .T-2, .T-3, .T-4, .T-5, .T-6, .T-7, .T-8, .T-9, .T-10, .T-11, .T-12, .M, .M-1, .M-2, .M-3, .M-4, .M-5, .M-6, .M-7, .M-8, .M-9, .M-10, .M-11, .M-12, .SM, .SM-1, .SM-2, .SM-3, .SM-4, .SM-5, .SM-6, .SM-7, .SM-8, .SM-9, .SM-10, .SM-11, .SM-12 {
  min-height: 1px;
  padding-left: 10px;
  padding-right: 10px;
}

.container, .container-fluid {
  margin-right: auto;
  margin-left: auto;
  padding-left: 10px;
  padding-right: 10px;
}

/*--------------------
  - GRID CONTAINER
  ---------------------*/
.container {
  width: 100%;
  max-width: 980px;
}

/*--------------------
  - GRID ROW
  ---------------------*/
.row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
  margin-right: -10px;
}

.row-fluid {
  display: flex;
  flex-wrap: wrap;
  margin-left: 0px;
  margin-right: 0px;
}

/*--------------------
  - GRID VERTICAL ALIGN
  ---------------------*/
.row.columns-top, .row-fluid.columns-top {
  align-items: flex-start;
}

.row.columns-bottom, .row-fluid.columns-bottom {
  align-items: flex-end;
}

.row.columns-middle, .row-fluid.columns-middle {
  align-items: center;
}

.row.columns-stretch, .row-fluid.columns-stretch {
  align-items: stretch;
}

/*--------------------
  - GRID HORIZONTAL ALIGN
  ---------------------*/
.row.columns-left, .row-fluid.columns-left {
  justify-content: flex-start;
}

.row.columns-right, .row-fluid.columns-right {
  justify-content: flex-end;
}

.row.columns-center, .row-fluid.columns-center {
  justify-content: center;
}

.row.columns-between, .row-fluid.columns-between {
  justify-content: space-between;
}

.row.columns-around, .row-fluid.columns-around {
  justify-content: space-around;
}

/*--------------------
  - COLUMN VERTICAL ALIGN
  ---------------------*/
.vertical-top {
  align-self: flex-start;
}

.vertical-middle {
  align-self: center;
}

.vertical-bottom {
  align-self: flex-end;
}

/*--------------------
  - GRID REMOVE GAB
  ---------------------*/
.row.no-gutter, .row-fluid.no-gutter {
  margin-left: 0;
  margin-right: 0;
}

.row.no-gutter>div, .row-fluid.no-gutter>div {
  padding-left: 0;
  padding-right: 0;
}

/*--------------------
  - CREATE A GRID
  ---------------------*/
.D {
  flex-grow: 1;
  flex-basis: 0;
  max-width: 100%;
}

.hidden-D {
  display: none;
}

.D-1 {
  flex: 0 0 8.33333%;
  max-width: 8.33333%;
}

.D-2 {
  flex: 0 0 16.66667%;
  max-width: 16.66667%;
}

.D-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.D-4 {
  flex: 0 0 33.33333%;
  max-width: 33.33333%;
}

.D-5 {
  flex: 0 0 41.66667%;
  max-width: 41.66667%;
}

.D-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.D-7 {
  flex: 0 0 58.33333%;
  max-width: 58.33333%;
}

.D-8 {
  flex: 0 0 66.66667%;
  max-width: 66.66667%;
}

.D-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.D-10 {
  flex: 0 0 83.33333%;
  max-width: 83.33333%;
}

.D-11 {
  flex: 0 0 91.66667%;
  max-width: 91.66667%;
}

.D-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.D-order-0 {
  order: 0;
}

.D-order-1 {
  order: 1;
}

.D-order-2 {
  order: 2;
}

.D-order-3 {
  order: 3;
}

.D-order-4 {
  order: 4;
}

.D-order-5 {
  order: 5;
}

.D-order-6 {
  order: 6;
}

.D-order-7 {
  order: 7;
}

.D-order-8 {
  order: 8;
}

.D-order-9 {
  order: 9;
}

.D-order-10 {
  order: 10;
}

.D-order-11 {
  order: 11;
}

.D-order-12 {
  order: 12;
}

.L {
  flex-grow: 1;
  flex-basis: 0;
  max-width: 100%;
}

@media (max-width: 1200px) {
  .L {
    flex-grow: 1;
    flex-basis: 100%;
    max-width: 100%;
  }
}

@media (max-width: 1200px) {
  .hidden-L {
    display: none;
  }

  .L-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .L-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .L-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .L-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .L-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .L-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .L-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .L-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .L-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .L-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .L-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .L-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .L-order-0 {
    order: 0;
  }

  .L-order-1 {
    order: 1;
  }

  .L-order-2 {
    order: 2;
  }

  .L-order-3 {
    order: 3;
  }

  .L-order-4 {
    order: 4;
  }

  .L-order-5 {
    order: 5;
  }

  .L-order-6 {
    order: 6;
  }

  .L-order-7 {
    order: 7;
  }

  .L-order-8 {
    order: 8;
  }

  .L-order-9 {
    order: 9;
  }

  .L-order-10 {
    order: 10;
  }

  .L-order-11 {
    order: 11;
  }

  .L-order-12 {
    order: 12;
  }
}

.T {
  flex-grow: 1;
  flex-basis: 0;
  max-width: 100%;
}

@media (max-width: 992px) {
  .T {
    flex-grow: 1;
    flex-basis: 100%;
    max-width: 100%;
  }
}

@media (max-width: 992px) {
  .hidden-T {
    display: none;
  }

  .T-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .T-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .T-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .T-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .T-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .T-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .T-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .T-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .T-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .T-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .T-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .T-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .T-order-0 {
    order: 0;
  }

  .T-order-1 {
    order: 1;
  }

  .T-order-2 {
    order: 2;
  }

  .T-order-3 {
    order: 3;
  }

  .T-order-4 {
    order: 4;
  }

  .T-order-5 {
    order: 5;
  }

  .T-order-6 {
    order: 6;
  }

  .T-order-7 {
    order: 7;
  }

  .T-order-8 {
    order: 8;
  }

  .T-order-9 {
    order: 9;
  }

  .T-order-10 {
    order: 10;
  }

  .T-order-11 {
    order: 11;
  }

  .T-order-12 {
    order: 12;
  }
}

.M {
  flex-grow: 1;
  flex-basis: 0;
  max-width: 100%;
}

@media (max-width: 768px) {
  .M {
    flex-grow: 1;
    flex-basis: 100%;
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .hidden-M {
    display: none;
  }

  .M-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .M-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .M-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .M-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .M-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .M-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .M-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .M-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .M-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .M-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .M-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .M-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .M-order-0 {
    order: 0;
  }

  .M-order-1 {
    order: 1;
  }

  .M-order-2 {
    order: 2;
  }

  .M-order-3 {
    order: 3;
  }

  .M-order-4 {
    order: 4;
  }

  .M-order-5 {
    order: 5;
  }

  .M-order-6 {
    order: 6;
  }

  .M-order-7 {
    order: 7;
  }

  .M-order-8 {
    order: 8;
  }

  .M-order-9 {
    order: 9;
  }

  .M-order-10 {
    order: 10;
  }

  .M-order-11 {
    order: 11;
  }

  .M-order-12 {
    order: 12;
  }
}

.SM {
  flex-grow: 1;
  flex-basis: 0;
  max-width: 100%;
}

@media (max-width: 568px) {
  .SM {
    flex-grow: 1;
    flex-basis: 100%;
    max-width: 100%;
  }
}

@media (max-width: 568px) {
  .hidden-SM {
    display: none;
  }

  .SM-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .SM-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .SM-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .SM-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .SM-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .SM-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .SM-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .SM-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .SM-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .SM-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .SM-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .SM-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .SM-order-0 {
    order: 0;
  }

  .SM-order-1 {
    order: 1;
  }

  .SM-order-2 {
    order: 2;
  }

  .SM-order-3 {
    order: 3;
  }

  .SM-order-4 {
    order: 4;
  }

  .SM-order-5 {
    order: 5;
  }

  .SM-order-6 {
    order: 6;
  }

  .SM-order-7 {
    order: 7;
  }

  .SM-order-8 {
    order: 8;
  }

  .SM-order-9 {
    order: 9;
  }

  .SM-order-10 {
    order: 10;
  }

  .SM-order-11 {
    order: 11;
  }

  .SM-order-12 {
    order: 12;
  }
}

*, ::after, ::before {
  box-sizing: border-box;
}

*, ::after, ::before {
  box-sizing: border-box;
}

html, body {
  min-height: 100vh;
}

body {
  font-family: tahoma;
  font-size: 13px;
  padding: 0;
  margin: 0;
  color: #808080;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.title, .sub-title {
  font-family: 'Nunito', sans-serif;
}

.title {
  color: #333333;
  font-size: 30px;
  font-weight: normal;
  margin-bottom: 10px;
  letter-spacing: 3px;
}

.title.white {
  color: #fff;
}

.title.big {
  font-size: 46px;
}

.sub-title {
  color: #333333;
  font-size: 18px;
}

.sub-title.white {
  color: #fff;
}

.text-label, .section2 span {
  display: inline-block;
  background: #fff;
  border-radius: 3px;
  padding: 3px 10px;
  margin-top: 3px;
  color: #48989B;
}

.text-label.dark, .section2 span.dark {
  background: #333333;
  color: #F8F8F8;
}

#root, .main-container {
  height: 100vh;
}

section {
  text-align: center;
  padding: 100px 40px;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

section pre, section pre.prettyprint {
  font-size: 13px;
  width: 100%;
  margin: 0;
  text-align: left;
  border-radius: 3px;
  border: 1px solid #222;
  padding: 40px 0;
  color: #eee;
  background: #333;
  overflow: auto;
}

section .center {
  flex: 1 0 100%;
}

.section2 {
  color: rgba(255, 255, 255, 0.7);
  background: #1E8184;
}

.section2 .title {
  color: #fff;
}

.section2 h3 {
  color: #0F4042;
  font-size: 26px;
  margin-bottom: 0;
}

.section3 {
  background: #333333;
}

.button {
  display: inline-block;
  text-decoration: none;
  font-family: 'Nunito', sans-serif;
  background: #0f4042;
  color: #fff;
  padding: 10px 30px;
  border-radius: 50px;
  font-size: 14px;
  width: 100%;
  max-width: 250px;
  margin: 10px;
}

.button.outline {
  background: none;
  color: #0f4042;
  border: 1px solid #0f4042;
}

.box-hover, .box-hover-2 {
  display: inline-block;
  width: 822px;
  height: 462px;
  margin-top: 30px;
  animation: Animate1 5s infinite alternate ease-in-out;
}

.border {
  position: absolute;
  left: 40px;
  right: 40px;
  bottom: 40px;
  top: 40px;
  border: 5px solid #fff;
  box-shadow: 0 0px 50px rgba(0, 0, 0, 0.1);
}

.box-title {
  animation: Animate2 3s infinite alternate ease-in-out;
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 100px;
  text-shadow: 0 0 80px rgba(0, 0, 0, 0.4);
  text-transform: uppercase;
}

.box-title .sub-title {
  color: #fff;
  font-size: 12px;
  letter-spacing: 2px;
}

.box-title .title {
  font-weight: bold;
  font-size: 60px;
  letter-spacing: 10px;
}

.item-animated {
  display: inline-block;
  width: 100px;
  height: 100px;
  background: #0f4042;
  margin: 60px 20px;
}

.custom-ui {
  text-align: center;
  width: 500px;
  padding: 40px;
  background: #282e30;
  box-shadow: 0 20px 75px rgba(0, 0, 0, 0.23);
  color: #fff;
}

.react-confirm-alert-overlay {
  background: rgb(34 34 34 / 90%) !important;
}

.custom-ui>h1 {
  margin-top: 0;
}

.custom-ui>button {
  width: 160px;
  padding: 10px;
  border: 1px solid #fff;
  margin: 10px;
  cursor: pointer;
  background: none;
  color: #fff;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/css/modal.css"],"names":[],"mappings":"AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;wBAEwB;AACxB;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;wBAEwB;AACxB;EAGE,aAAa;EAEb,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EAGE,aAAa;EAEb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;wBAEwB;AACxB;EAGE,uBAAuB;AACzB;;AAEA;EAGE,qBAAqB;AACvB;;AAEA;EAGE,mBAAmB;AACrB;;AAEA;EAGE,oBAAoB;AACtB;;AAEA;;wBAEwB;AACxB;EAGE,2BAA2B;AAC7B;;AAEA;EAGE,yBAAyB;AAC3B;;AAEA;EAGE,uBAAuB;AACzB;;AAEA;EAGE,8BAA8B;AAChC;;AAEA;EAEE,6BAA6B;AAC/B;;AAEA;;wBAEwB;AACxB;EAEE,sBAAsB;AACxB;;AAEA;EAGE,kBAAkB;AACpB;;AAEA;EAEE,oBAAoB;AACtB;;AAEA;;wBAEwB;AACxB;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;wBAEwB;AACxB;EAGE,YAAY;EAEZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EAGE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EAGE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EAGE,aAAa;EACb,cAAc;AAChB;;AAEA;EAGE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EAGE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EAGE,aAAa;EACb,cAAc;AAChB;;AAEA;EAGE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EAGE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EAGE,aAAa;EACb,cAAc;AAChB;;AAEA;EAGE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EAGE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EAGE,cAAc;EACd,eAAe;AACjB;;AAEA;EAGE,QAAQ;AACV;;AAEA;EAGE,QAAQ;AACV;;AAEA;EAGE,QAAQ;AACV;;AAEA;EAGE,QAAQ;AACV;;AAEA;EAGE,QAAQ;AACV;;AAEA;EAGE,QAAQ;AACV;;AAEA;EAGE,QAAQ;AACV;;AAEA;EAGE,QAAQ;AACV;;AAEA;EAGE,QAAQ;AACV;;AAEA;EAGE,QAAQ;AACV;;AAEA;EAGE,SAAS;AACX;;AAEA;EAGE,SAAS;AACX;;AAEA;EAGE,SAAS;AACX;;AAEA;EAGE,YAAY;EAEZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IAGE,YAAY;IAEZ,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,aAAa;IACb,cAAc;EAChB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,aAAa;IACb,cAAc;EAChB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,aAAa;IACb,cAAc;EAChB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,cAAc;IACd,eAAe;EACjB;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,SAAS;EACX;;EAEA;IAGE,SAAS;EACX;;EAEA;IAGE,SAAS;EACX;AACF;;AAEA;EAGE,YAAY;EAEZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IAGE,YAAY;IAEZ,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,aAAa;IACb,cAAc;EAChB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,aAAa;IACb,cAAc;EAChB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,aAAa;IACb,cAAc;EAChB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,cAAc;IACd,eAAe;EACjB;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,SAAS;EACX;;EAEA;IAGE,SAAS;EACX;;EAEA;IAGE,SAAS;EACX;AACF;;AAEA;EAGE,YAAY;EAEZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IAGE,YAAY;IAEZ,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,aAAa;IACb,cAAc;EAChB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,aAAa;IACb,cAAc;EAChB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,aAAa;IACb,cAAc;EAChB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,cAAc;IACd,eAAe;EACjB;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,SAAS;EACX;;EAEA;IAGE,SAAS;EACX;;EAEA;IAGE,SAAS;EACX;AACF;;AAEA;EAGE,YAAY;EAEZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IAGE,YAAY;IAEZ,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,aAAa;IACb,cAAc;EAChB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,aAAa;IACb,cAAc;EAChB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,aAAa;IACb,cAAc;EAChB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IAGE,cAAc;IACd,eAAe;EACjB;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,QAAQ;EACV;;EAEA;IAGE,SAAS;EACX;;EAEA;IAGE,SAAS;EACX;;EAEA;IAGE,SAAS;EACX;AACF;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EAEE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EAGb,aAAa;EAGb,uBAAuB;EAGvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EAGE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,iCAAiC;EACjC,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAEhB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;EACT,sBAAsB;EAEtB,yCAAyC;AAC3C;;AAEA;EAEE,qDAAqD;EACrD,kBAAkB;EAClB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Nunito:400,900\");\n\n.D, .D-1, .D-2, .D-3, .D-4, .D-5, .D-6, .D-7, .D-8, .D-9, .D-10, .D-11, .D-12, .L, .L-1, .L-2, .L-3, .L-4, .L-5, .L-6, .L-7, .L-8, .L-9, .L-10, .L-11, .L-12, .T, .T-1, .T-2, .T-3, .T-4, .T-5, .T-6, .T-7, .T-8, .T-9, .T-10, .T-11, .T-12, .M, .M-1, .M-2, .M-3, .M-4, .M-5, .M-6, .M-7, .M-8, .M-9, .M-10, .M-11, .M-12, .SM, .SM-1, .SM-2, .SM-3, .SM-4, .SM-5, .SM-6, .SM-7, .SM-8, .SM-9, .SM-10, .SM-11, .SM-12 {\n  min-height: 1px;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.container, .container-fluid {\n  margin-right: auto;\n  margin-left: auto;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n/*--------------------\n  - GRID CONTAINER\n  ---------------------*/\n.container {\n  width: 100%;\n  max-width: 980px;\n}\n\n/*--------------------\n  - GRID ROW\n  ---------------------*/\n.row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-left: -10px;\n  margin-right: -10px;\n}\n\n.row-fluid {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-left: 0px;\n  margin-right: 0px;\n}\n\n/*--------------------\n  - GRID VERTICAL ALIGN\n  ---------------------*/\n.row.columns-top, .row-fluid.columns-top {\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n}\n\n.row.columns-bottom, .row-fluid.columns-bottom {\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n}\n\n.row.columns-middle, .row-fluid.columns-middle {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.row.columns-stretch, .row-fluid.columns-stretch {\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n\n/*--------------------\n  - GRID HORIZONTAL ALIGN\n  ---------------------*/\n.row.columns-left, .row-fluid.columns-left {\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n\n.row.columns-right, .row-fluid.columns-right {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n\n.row.columns-center, .row-fluid.columns-center {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.row.columns-between, .row-fluid.columns-between {\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.row.columns-around, .row-fluid.columns-around {\n  -ms-flex-pack: distribute;\n  justify-content: space-around;\n}\n\n/*--------------------\n  - COLUMN VERTICAL ALIGN\n  ---------------------*/\n.vertical-top {\n  -ms-flex-item-align: start;\n  align-self: flex-start;\n}\n\n.vertical-middle {\n  -ms-flex-item-align: center;\n  -ms-grid-row-align: center;\n  align-self: center;\n}\n\n.vertical-bottom {\n  -ms-flex-item-align: end;\n  align-self: flex-end;\n}\n\n/*--------------------\n  - GRID REMOVE GAB\n  ---------------------*/\n.row.no-gutter, .row-fluid.no-gutter {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.row.no-gutter>div, .row-fluid.no-gutter>div {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n/*--------------------\n  - CREATE A GRID\n  ---------------------*/\n.D {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-preferred-size: 0;\n  flex-basis: 0;\n  max-width: 100%;\n}\n\n.hidden-D {\n  display: none;\n}\n\n.D-1 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 8.33333%;\n  flex: 0 0 8.33333%;\n  max-width: 8.33333%;\n}\n\n.D-2 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 16.66667%;\n  flex: 0 0 16.66667%;\n  max-width: 16.66667%;\n}\n\n.D-3 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 25%;\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.D-4 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 33.33333%;\n  flex: 0 0 33.33333%;\n  max-width: 33.33333%;\n}\n\n.D-5 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 41.66667%;\n  flex: 0 0 41.66667%;\n  max-width: 41.66667%;\n}\n\n.D-6 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 50%;\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.D-7 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 58.33333%;\n  flex: 0 0 58.33333%;\n  max-width: 58.33333%;\n}\n\n.D-8 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 66.66667%;\n  flex: 0 0 66.66667%;\n  max-width: 66.66667%;\n}\n\n.D-9 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 75%;\n  flex: 0 0 75%;\n  max-width: 75%;\n}\n\n.D-10 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 83.33333%;\n  flex: 0 0 83.33333%;\n  max-width: 83.33333%;\n}\n\n.D-11 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 91.66667%;\n  flex: 0 0 91.66667%;\n  max-width: 91.66667%;\n}\n\n.D-12 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 100%;\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n.D-order-0 {\n  -webkit-box-ordinal-group: 1;\n  -ms-flex-order: 0;\n  order: 0;\n}\n\n.D-order-1 {\n  -webkit-box-ordinal-group: 2;\n  -ms-flex-order: 1;\n  order: 1;\n}\n\n.D-order-2 {\n  -webkit-box-ordinal-group: 3;\n  -ms-flex-order: 2;\n  order: 2;\n}\n\n.D-order-3 {\n  -webkit-box-ordinal-group: 4;\n  -ms-flex-order: 3;\n  order: 3;\n}\n\n.D-order-4 {\n  -webkit-box-ordinal-group: 5;\n  -ms-flex-order: 4;\n  order: 4;\n}\n\n.D-order-5 {\n  -webkit-box-ordinal-group: 6;\n  -ms-flex-order: 5;\n  order: 5;\n}\n\n.D-order-6 {\n  -webkit-box-ordinal-group: 7;\n  -ms-flex-order: 6;\n  order: 6;\n}\n\n.D-order-7 {\n  -webkit-box-ordinal-group: 8;\n  -ms-flex-order: 7;\n  order: 7;\n}\n\n.D-order-8 {\n  -webkit-box-ordinal-group: 9;\n  -ms-flex-order: 8;\n  order: 8;\n}\n\n.D-order-9 {\n  -webkit-box-ordinal-group: 10;\n  -ms-flex-order: 9;\n  order: 9;\n}\n\n.D-order-10 {\n  -webkit-box-ordinal-group: 11;\n  -ms-flex-order: 10;\n  order: 10;\n}\n\n.D-order-11 {\n  -webkit-box-ordinal-group: 12;\n  -ms-flex-order: 11;\n  order: 11;\n}\n\n.D-order-12 {\n  -webkit-box-ordinal-group: 13;\n  -ms-flex-order: 12;\n  order: 12;\n}\n\n.L {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-preferred-size: 0;\n  flex-basis: 0;\n  max-width: 100%;\n}\n\n@media (max-width: 1200px) {\n  .L {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    -ms-flex-preferred-size: 100%;\n    flex-basis: 100%;\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 1200px) {\n  .hidden-L {\n    display: none;\n  }\n\n  .L-1 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 8.33333%;\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n  }\n\n  .L-2 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 16.66667%;\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n\n  .L-3 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .L-4 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 33.33333%;\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n\n  .L-5 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 41.66667%;\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n  }\n\n  .L-6 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .L-7 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 58.33333%;\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n  }\n\n  .L-8 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 66.66667%;\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n  }\n\n  .L-9 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .L-10 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 83.33333%;\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n  }\n\n  .L-11 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 91.66667%;\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n  }\n\n  .L-12 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .L-order-0 {\n    -webkit-box-ordinal-group: 1;\n    -ms-flex-order: 0;\n    order: 0;\n  }\n\n  .L-order-1 {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    order: 1;\n  }\n\n  .L-order-2 {\n    -webkit-box-ordinal-group: 3;\n    -ms-flex-order: 2;\n    order: 2;\n  }\n\n  .L-order-3 {\n    -webkit-box-ordinal-group: 4;\n    -ms-flex-order: 3;\n    order: 3;\n  }\n\n  .L-order-4 {\n    -webkit-box-ordinal-group: 5;\n    -ms-flex-order: 4;\n    order: 4;\n  }\n\n  .L-order-5 {\n    -webkit-box-ordinal-group: 6;\n    -ms-flex-order: 5;\n    order: 5;\n  }\n\n  .L-order-6 {\n    -webkit-box-ordinal-group: 7;\n    -ms-flex-order: 6;\n    order: 6;\n  }\n\n  .L-order-7 {\n    -webkit-box-ordinal-group: 8;\n    -ms-flex-order: 7;\n    order: 7;\n  }\n\n  .L-order-8 {\n    -webkit-box-ordinal-group: 9;\n    -ms-flex-order: 8;\n    order: 8;\n  }\n\n  .L-order-9 {\n    -webkit-box-ordinal-group: 10;\n    -ms-flex-order: 9;\n    order: 9;\n  }\n\n  .L-order-10 {\n    -webkit-box-ordinal-group: 11;\n    -ms-flex-order: 10;\n    order: 10;\n  }\n\n  .L-order-11 {\n    -webkit-box-ordinal-group: 12;\n    -ms-flex-order: 11;\n    order: 11;\n  }\n\n  .L-order-12 {\n    -webkit-box-ordinal-group: 13;\n    -ms-flex-order: 12;\n    order: 12;\n  }\n}\n\n.T {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-preferred-size: 0;\n  flex-basis: 0;\n  max-width: 100%;\n}\n\n@media (max-width: 992px) {\n  .T {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    -ms-flex-preferred-size: 100%;\n    flex-basis: 100%;\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 992px) {\n  .hidden-T {\n    display: none;\n  }\n\n  .T-1 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 8.33333%;\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n  }\n\n  .T-2 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 16.66667%;\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n\n  .T-3 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .T-4 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 33.33333%;\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n\n  .T-5 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 41.66667%;\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n  }\n\n  .T-6 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .T-7 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 58.33333%;\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n  }\n\n  .T-8 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 66.66667%;\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n  }\n\n  .T-9 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .T-10 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 83.33333%;\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n  }\n\n  .T-11 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 91.66667%;\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n  }\n\n  .T-12 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .T-order-0 {\n    -webkit-box-ordinal-group: 1;\n    -ms-flex-order: 0;\n    order: 0;\n  }\n\n  .T-order-1 {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    order: 1;\n  }\n\n  .T-order-2 {\n    -webkit-box-ordinal-group: 3;\n    -ms-flex-order: 2;\n    order: 2;\n  }\n\n  .T-order-3 {\n    -webkit-box-ordinal-group: 4;\n    -ms-flex-order: 3;\n    order: 3;\n  }\n\n  .T-order-4 {\n    -webkit-box-ordinal-group: 5;\n    -ms-flex-order: 4;\n    order: 4;\n  }\n\n  .T-order-5 {\n    -webkit-box-ordinal-group: 6;\n    -ms-flex-order: 5;\n    order: 5;\n  }\n\n  .T-order-6 {\n    -webkit-box-ordinal-group: 7;\n    -ms-flex-order: 6;\n    order: 6;\n  }\n\n  .T-order-7 {\n    -webkit-box-ordinal-group: 8;\n    -ms-flex-order: 7;\n    order: 7;\n  }\n\n  .T-order-8 {\n    -webkit-box-ordinal-group: 9;\n    -ms-flex-order: 8;\n    order: 8;\n  }\n\n  .T-order-9 {\n    -webkit-box-ordinal-group: 10;\n    -ms-flex-order: 9;\n    order: 9;\n  }\n\n  .T-order-10 {\n    -webkit-box-ordinal-group: 11;\n    -ms-flex-order: 10;\n    order: 10;\n  }\n\n  .T-order-11 {\n    -webkit-box-ordinal-group: 12;\n    -ms-flex-order: 11;\n    order: 11;\n  }\n\n  .T-order-12 {\n    -webkit-box-ordinal-group: 13;\n    -ms-flex-order: 12;\n    order: 12;\n  }\n}\n\n.M {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-preferred-size: 0;\n  flex-basis: 0;\n  max-width: 100%;\n}\n\n@media (max-width: 768px) {\n  .M {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    -ms-flex-preferred-size: 100%;\n    flex-basis: 100%;\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .hidden-M {\n    display: none;\n  }\n\n  .M-1 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 8.33333%;\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n  }\n\n  .M-2 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 16.66667%;\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n\n  .M-3 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .M-4 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 33.33333%;\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n\n  .M-5 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 41.66667%;\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n  }\n\n  .M-6 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .M-7 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 58.33333%;\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n  }\n\n  .M-8 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 66.66667%;\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n  }\n\n  .M-9 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .M-10 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 83.33333%;\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n  }\n\n  .M-11 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 91.66667%;\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n  }\n\n  .M-12 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .M-order-0 {\n    -webkit-box-ordinal-group: 1;\n    -ms-flex-order: 0;\n    order: 0;\n  }\n\n  .M-order-1 {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    order: 1;\n  }\n\n  .M-order-2 {\n    -webkit-box-ordinal-group: 3;\n    -ms-flex-order: 2;\n    order: 2;\n  }\n\n  .M-order-3 {\n    -webkit-box-ordinal-group: 4;\n    -ms-flex-order: 3;\n    order: 3;\n  }\n\n  .M-order-4 {\n    -webkit-box-ordinal-group: 5;\n    -ms-flex-order: 4;\n    order: 4;\n  }\n\n  .M-order-5 {\n    -webkit-box-ordinal-group: 6;\n    -ms-flex-order: 5;\n    order: 5;\n  }\n\n  .M-order-6 {\n    -webkit-box-ordinal-group: 7;\n    -ms-flex-order: 6;\n    order: 6;\n  }\n\n  .M-order-7 {\n    -webkit-box-ordinal-group: 8;\n    -ms-flex-order: 7;\n    order: 7;\n  }\n\n  .M-order-8 {\n    -webkit-box-ordinal-group: 9;\n    -ms-flex-order: 8;\n    order: 8;\n  }\n\n  .M-order-9 {\n    -webkit-box-ordinal-group: 10;\n    -ms-flex-order: 9;\n    order: 9;\n  }\n\n  .M-order-10 {\n    -webkit-box-ordinal-group: 11;\n    -ms-flex-order: 10;\n    order: 10;\n  }\n\n  .M-order-11 {\n    -webkit-box-ordinal-group: 12;\n    -ms-flex-order: 11;\n    order: 11;\n  }\n\n  .M-order-12 {\n    -webkit-box-ordinal-group: 13;\n    -ms-flex-order: 12;\n    order: 12;\n  }\n}\n\n.SM {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-preferred-size: 0;\n  flex-basis: 0;\n  max-width: 100%;\n}\n\n@media (max-width: 568px) {\n  .SM {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    -ms-flex-preferred-size: 100%;\n    flex-basis: 100%;\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 568px) {\n  .hidden-SM {\n    display: none;\n  }\n\n  .SM-1 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 8.33333%;\n    flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n  }\n\n  .SM-2 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 16.66667%;\n    flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n\n  .SM-3 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 25%;\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n\n  .SM-4 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 33.33333%;\n    flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n\n  .SM-5 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 41.66667%;\n    flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n  }\n\n  .SM-6 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 50%;\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .SM-7 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 58.33333%;\n    flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n  }\n\n  .SM-8 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 66.66667%;\n    flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n  }\n\n  .SM-9 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 75%;\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n\n  .SM-10 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 83.33333%;\n    flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n  }\n\n  .SM-11 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 91.66667%;\n    flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n  }\n\n  .SM-12 {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 100%;\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n\n  .SM-order-0 {\n    -webkit-box-ordinal-group: 1;\n    -ms-flex-order: 0;\n    order: 0;\n  }\n\n  .SM-order-1 {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    order: 1;\n  }\n\n  .SM-order-2 {\n    -webkit-box-ordinal-group: 3;\n    -ms-flex-order: 2;\n    order: 2;\n  }\n\n  .SM-order-3 {\n    -webkit-box-ordinal-group: 4;\n    -ms-flex-order: 3;\n    order: 3;\n  }\n\n  .SM-order-4 {\n    -webkit-box-ordinal-group: 5;\n    -ms-flex-order: 4;\n    order: 4;\n  }\n\n  .SM-order-5 {\n    -webkit-box-ordinal-group: 6;\n    -ms-flex-order: 5;\n    order: 5;\n  }\n\n  .SM-order-6 {\n    -webkit-box-ordinal-group: 7;\n    -ms-flex-order: 6;\n    order: 6;\n  }\n\n  .SM-order-7 {\n    -webkit-box-ordinal-group: 8;\n    -ms-flex-order: 7;\n    order: 7;\n  }\n\n  .SM-order-8 {\n    -webkit-box-ordinal-group: 9;\n    -ms-flex-order: 8;\n    order: 8;\n  }\n\n  .SM-order-9 {\n    -webkit-box-ordinal-group: 10;\n    -ms-flex-order: 9;\n    order: 9;\n  }\n\n  .SM-order-10 {\n    -webkit-box-ordinal-group: 11;\n    -ms-flex-order: 10;\n    order: 10;\n  }\n\n  .SM-order-11 {\n    -webkit-box-ordinal-group: 12;\n    -ms-flex-order: 11;\n    order: 11;\n  }\n\n  .SM-order-12 {\n    -webkit-box-ordinal-group: 13;\n    -ms-flex-order: 12;\n    order: 12;\n  }\n}\n\n*, ::after, ::before {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n*, ::after, ::before {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\nhtml, body {\n  min-height: 100vh;\n}\n\nbody {\n  font-family: tahoma;\n  font-size: 13px;\n  padding: 0;\n  margin: 0;\n  color: #808080;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.title, .sub-title {\n  font-family: 'Nunito', sans-serif;\n}\n\n.title {\n  color: #333333;\n  font-size: 30px;\n  font-weight: normal;\n  margin-bottom: 10px;\n  letter-spacing: 3px;\n}\n\n.title.white {\n  color: #fff;\n}\n\n.title.big {\n  font-size: 46px;\n}\n\n.sub-title {\n  color: #333333;\n  font-size: 18px;\n}\n\n.sub-title.white {\n  color: #fff;\n}\n\n.text-label, .section2 span {\n  display: inline-block;\n  background: #fff;\n  border-radius: 3px;\n  padding: 3px 10px;\n  margin-top: 3px;\n  color: #48989B;\n}\n\n.text-label.dark, .section2 span.dark {\n  background: #333333;\n  color: #F8F8F8;\n}\n\n#root, .main-container {\n  height: 100vh;\n}\n\nsection {\n  text-align: center;\n  padding: 100px 40px;\n  width: 100%;\n  height: 100vh;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\nsection pre, section pre.prettyprint {\n  font-size: 13px;\n  width: 100%;\n  margin: 0;\n  text-align: left;\n  border-radius: 3px;\n  border: 1px solid #222;\n  padding: 40px 0;\n  color: #eee;\n  background: #333;\n  overflow: auto;\n}\n\nsection .center {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 100%;\n  flex: 1 0 100%;\n}\n\n.section2 {\n  color: rgba(255, 255, 255, 0.7);\n  background: #1E8184;\n}\n\n.section2 .title {\n  color: #fff;\n}\n\n.section2 h3 {\n  color: #0F4042;\n  font-size: 26px;\n  margin-bottom: 0;\n}\n\n.section3 {\n  background: #333333;\n}\n\n.button {\n  display: inline-block;\n  text-decoration: none;\n  font-family: 'Nunito', sans-serif;\n  background: #0f4042;\n  color: #fff;\n  padding: 10px 30px;\n  border-radius: 50px;\n  font-size: 14px;\n  width: 100%;\n  max-width: 250px;\n  margin: 10px;\n}\n\n.button.outline {\n  background: none;\n  color: #0f4042;\n  border: 1px solid #0f4042;\n}\n\n.box-hover, .box-hover-2 {\n  display: inline-block;\n  width: 822px;\n  height: 462px;\n  margin-top: 30px;\n  -webkit-animation: Animate1 5s infinite alternate ease-in-out;\n  animation: Animate1 5s infinite alternate ease-in-out;\n}\n\n.border {\n  position: absolute;\n  left: 40px;\n  right: 40px;\n  bottom: 40px;\n  top: 40px;\n  border: 5px solid #fff;\n  -webkit-box-shadow: 0 0px 50px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0px 50px rgba(0, 0, 0, 0.1);\n}\n\n.box-title {\n  -webkit-animation: Animate2 3s infinite alternate ease-in-out;\n  animation: Animate2 3s infinite alternate ease-in-out;\n  text-align: center;\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 100px;\n  text-shadow: 0 0 80px rgba(0, 0, 0, 0.4);\n  text-transform: uppercase;\n}\n\n.box-title .sub-title {\n  color: #fff;\n  font-size: 12px;\n  letter-spacing: 2px;\n}\n\n.box-title .title {\n  font-weight: bold;\n  font-size: 60px;\n  letter-spacing: 10px;\n}\n\n.item-animated {\n  display: inline-block;\n  width: 100px;\n  height: 100px;\n  background: #0f4042;\n  margin: 60px 20px;\n}\n\n.custom-ui {\n  text-align: center;\n  width: 500px;\n  padding: 40px;\n  background: #282e30;\n  box-shadow: 0 20px 75px rgba(0, 0, 0, 0.23);\n  color: #fff;\n}\n\n.react-confirm-alert-overlay {\n  background: rgb(34 34 34 / 90%) !important;\n}\n\n.custom-ui>h1 {\n  margin-top: 0;\n}\n\n.custom-ui>button {\n  width: 160px;\n  padding: 10px;\n  border: 1px solid #fff;\n  margin: 10px;\n  cursor: pointer;\n  background: none;\n  color: #fff;\n  font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
